/* src/components/core/AboutPage.js */

import React from 'react';
import Navbar from '../components/core/Navbar';
import Footer from '../components/core/Footer';
import './AboutPage.css';

const AboutPage = () => (
  <>
    <Navbar />
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div
          className="about-hero-background"
          style={{
            backgroundImage: `url('/assets/about_us.png')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <div className="container">
            <h1>About Us</h1>
            <p className="hero-subheadline">
              You don't need to be a trader, coder, or crypto bro to make smarter moves with your money.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="about-content">
        <div className="container">
          <div className="content-section">
            <p className="intro-text">
              At Numerease, we're making an overlooked opportunity in tech and finance actually accessible — no jargon, no hype.
            </p>
          </div>

          <div className="content-section">
            <h2>What we do</h2>
            <p>
              We help you grow a token called NMR, by putting it to work behind the scenes of a hedge fund powered by AI. You choose a top-performing prediction model (we make that part easy), and we automate the rest — submissions, staking, and earning. Five days a week. Zero code required.
            </p>
          </div>

          <div className="content-section">
            <h2>Why it matters</h2>
            <p>
              Crypto's had a weird reputation. But underneath the noise, it's also a new kind of financial system — one that doesn't rely on banks or borders.
            </p>
            <p>
              Used wisely, it can be a hedge against inflation, a way to diversify beyond the dollar, or simply a smarter place to park a small slice of your net worth.
            </p>
            <p>
              Numerease helps you do that — intelligently, effortlessly, and without pretending to be someone you're not.
            </p>
          </div>

          <div className="content-section">
            <h2>Who we're for</h2>
            <p>
              This is for people who are curious about the future — not obsessed with crypto.
            </p>
            <p>
              For people who want to participate, without going full degen.
            </p>
            <p>
              For people who value clarity, automation, and smart systems over hype.
            </p>
          </div>
        </div>
      </section>
    </div>
    <Footer />
  </>
);

export default AboutPage;

